angular.module('dpw.components')
    .directive('dpwDatePicker', [function () {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                pickerOptions: '=',
                instance: '=?',
                defaultDate: '<?'
            },
            link: function (scope, element, attrs, ngModel) {
                if (!ngModel) {
                    RCDPW.console.warn('Missing ngModel');
                    return;
                }
                element.addClass('dpw-date-picker');
                scope.instance = scope.fp =
                    flatpickr(element[0], _.assign(scope.pickerOptions, {'defaultDate': scope.defaultDate}));

                scope.$watch('pickerOptions', function (newValue, oldValue) {
                    if (!angular.equals(newValue, oldValue)) {
                        Object.keys(scope.pickerOptions).forEach(function (key) {
                            scope.fp.set(key, scope.pickerOptions[key]);
                        });
                    }
                });
            }
        };
    }]);
